const priorityApiErrorEventLog = (error, payLoadBody) => {
  if (window?.spnGlobalConfig?.GV2_GODAVARI_ERROR?.priority) {
    window.spnGlobalConfig.GV2_GODAVARI_ERROR.priority.push({
      status: error?.errorObj?.status || error?.status,
      message: error?.errorObj?.message || error?.message,
      eventName: payLoadBody?.event_name,
      event_id: payLoadBody?.event_id,
    });
  }
};

const batchedApiErrorEventLog = (error, payLoadBody) => {
  let errorEventList = '';
  if (payLoadBody.length > 0) {
    for (let errIndex = 0; errIndex < payLoadBody.length; errIndex++) {
      errorEventList += payLoadBody[errIndex].event_name + ',';
    }
    if (errorEventList.endsWith(',')) {
      errorEventList = errorEventList.slice(0, -1);
    }
  }
  if (window?.spnGlobalConfig?.GV2_GODAVARI_ERROR?.batched) {
    window.spnGlobalConfig.GV2_GODAVARI_ERROR.batched.push({
      status: error?.errorObj?.status || error?.status,
      message: error?.errorObj?.message || error?.message,
      EventList: errorEventList,
      batch_id: payLoadBody[0]?.batch_id,
    });
  }
};

export { priorityApiErrorEventLog, batchedApiErrorEventLog };
